import React from 'react'
import { Rating } from '@mui/material';
import styles from './GoogleRating.module.scss';
import { Star, StarBorder } from '@mui/icons-material';

const GoogleRating = ({ rating = 4.5, reviews = 538 }) => {
  return (
    <div className={styles.googleRating}>
      <img src="images/G_logo.svg" alt="Google Logo" className={styles.googleLogo} />
      <div>
        <div className={styles.ratingStars}>
          <b style={{fontSize: '1rem', paddingRight: '0.5rem'}}>{rating}</b>
          <Rating
            name="googleRating"
            value={rating}
            readOnly
            precision={0.25}
            emptyIcon={<StarBorder className={styles.starIconInactive} />}
            icon={<Star className={styles.starIconActive} />}
          />
        </div>
        <span>
          {reviews} Reviews
        </span>
      </div>
    </div>
  );
};

export default GoogleRating;